export const REDO_LOADED_ON_CART_ATTRIBUTE_KEY = "__redo_loaded_on_cart";
export const REDO_OPTED_IN_FROM_CART_ATTRIBUTE_KEY = "redo_opted_in_from_cart";
